import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api, fmtDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setItems(r.data)); }, []);
  return (
    <Layout title="Auditoria" subtitle="Histórico completo de operações">
      <Card className="rounded-sm overflow-hidden">
        <Table>
          <TableHeader className="bg-secondary/60"><TableRow><TableHead>Data/Hora</TableHead><TableHead>Usuário</TableHead><TableHead>Ação</TableHead><TableHead>Entidade</TableHead><TableHead>ID</TableHead><TableHead>Detalhes</TableHead></TableRow></TableHeader>
          <TableBody>{items.map(a => (
            <TableRow key={a.id}>
              <TableCell className="text-xs">{fmtDate(a.timestamp)} {new Date(a.timestamp).toLocaleTimeString("pt-BR")}</TableCell>
              <TableCell>{a.user_name}</TableCell>
              <TableCell><Badge variant="secondary" className="capitalize">{a.action}</Badge></TableCell>
              <TableCell className="capitalize">{a.entity}</TableCell>
              <TableCell className="font-mono text-[10px] text-muted-foreground">{a.entity_id?.slice(0, 8)}</TableCell>
              <TableCell className="text-xs text-muted-foreground">{JSON.stringify(a.details)}</TableCell>
            </TableRow>
          ))}{items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-6">Sem registros</TableCell></TableRow>}</TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
